// The app's icon set. VisionHeight's design uses Lucide icons, so all icons
// come from lucide-react (NOT @mui/icons-material) — re-exported here so there's
// one place to see/swap the set. Lucide icons inherit `currentColor`, so tint
// them via the parent's `color` (theme tokens).
export {
  Building2,
  Headset,
  Home,
  Shield,
  Unplug,
  BriefcaseBusiness,
  Server,
  TriangleAlert,
  CircleAlert,
  CircleCheck,
  Rss,
  Drama,
  BookOpen,
  Settings,
  CircleUserRound,
  MessagesSquare,
  MessageCircle,
  LayoutDashboard,
  Cable,
  PanelLeft,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  Plus,
  SquarePen,
  Search,
  SearchX,
  ArrowUp,
  ArrowDown,
  ChevronsUpDown,
  ChevronDown,
  ChevronUp,
  Maximize2,
  Minimize2,
  X,
  Pencil,
  EllipsisVertical,
  Folder,
  Globe,
  Radar,
  Download,
  FileText,
  Trash2,
  Square,
  Copy,
  CodeXml,
  Check,
  Eye,
  EyeOff,
  Paperclip,
  SquareSlash,
  LogOut,
  RefreshCw,
} from "lucide-react";

// Match the design's thin line weight (the exported SVGs are ~1px on a 16 grid).
export const ICON_STROKE = 1.5;
